import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchText: "",
};

export const isSearchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchText: (state, actions) => {
      state.searchText = actions.payload;
    },
  },
});

export const { setSearchText } = isSearchSlice.actions;

export default isSearchSlice.reducer;
